// extracted by mini-css-extract-plugin
export default {"wrap":"BG-z","fullWidth":"CG-z","hideOnDesktop":"DG-z","content":"EG-z","hasOpenedNav":"FG-z","crumbsList":"GG-z","dropdownsWrap":"HG-z"};